export default __webpack_public_path__ + "static/toolbar-light-5f20275b0cc3d274bc746985f6a5d756.mp4";